import React, { useState, useEffect } from "react";
import { getClientByEmail } from "../services/clientService";
import axios from "axios";
import"./../styles/accueil/profilclient.css";
import { updateClient } from "../services/clientService";

function ProfilClient() {
  const [client, setClient] = useState(null);
  const [formData, setFormData] = useState({});
  const [message, setMessage] = useState("");

  const clientConnecte = JSON.parse(localStorage.getItem("clientConnecte") || "{}");

  useEffect(() => {
    if (clientConnecte?.email) {
      getClientByEmail(clientConnecte.email)
        .then(clientData => {
          setClient(clientData);
          setFormData(clientData);
        })
        .catch(err => console.error("Erreur getClientByEmail :", err));
    }
  }, [clientConnecte?.email]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

 const handleUpdate = async (e) => {
  e.preventDefault();

  if (formData.telephone.length !== 10) {
    setMessage("❌ Le numéro de téléphone doit contenir 10 chiffres.");
    return;
  }

  try {
    await updateClient(clientConnecte.email, formData);
    setMessage("✅ Profil mis à jour avec succès !");
    localStorage.setItem("clientConnecte", JSON.stringify(formData));
    setClient(formData);
  } catch (err) {
    console.error(err);
    setMessage("❌ Erreur lors de la mise à jour du profil.");
  }
};


  const handleReset = () => {
    setFormData(client);
    setMessage("");
  };

  if (!client) return <p>Chargement...</p>;

  return (
    <div className="profil-client-container">
      <h2>Mon profil</h2>
      {message && <p className={`message ${message.includes("✅") ? "success" : "error"}`}>{message}</p>}

      <form className="profil-form" onSubmit={handleUpdate}>
        <div className="form-group">
          <label>Nom :</label>
          <input
            type="text"
            name="nom"
            value={formData.nom || ""}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Prénom :</label>
          <input
            type="text"
            name="prenom"
            value={formData.prenom || ""}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Téléphone :</label>
          <input
          type="text"
          name="telephone"
          value={formData.telephone || ""}
          onChange={(e) => {
            const value = e.target.value.replace(/\D/g, ""); 
            if (value.length <= 10) {
              setFormData({ ...formData, telephone: value });
            }
          }}
          required
        />

        </div>

        <div className="form-group">
          <label>Adresse :</label>
          <input
            type="text"
            name="adresse"
            value={formData.adresse || ""}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Email :</label>
          <input
            type="email"
            name="email"
            value={formData.email || ""}
            disabled
          />
        </div>

        <div className="form-buttons">
          <button type="submit" className="btn save-btn">Enregistrer</button>
          <button type="button" onClick={handleReset} className="btn cancel-btn">Annuler</button>
        </div>
      </form>
    </div>
  );
}

export default ProfilClient;
